import type { CodesDetail, ProductParams } from '@/api/model/basicTypes'
import type { State } from '.'

import usePageData, { Feature } from '@/hooks/core/usePageData'
import { PageCode } from '@/hooks/core/usePageData'

export default (): State => {
  const { loadPageData } = usePageData()

  return {
    folderName: loadPageData(PageCode.PRODUCT_LIST, Feature.INITIALIZATION)?.folderName ?? '',
    fileName: loadPageData(PageCode.PRODUCT_LIST, Feature.INITIALIZATION)?.fileName ?? '',

    documentTypeInfo: {} as CodesDetail,
    productTable: [] as any,

    documentType:
      loadPageData(PageCode.PRODUCT_LIST, Feature.INITIALIZATION)?.documentType ?? '',

    // 商品一覧画面・検索条件
    productListParam: {} as ProductParams,
  }
}
